// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/split_supply_plan_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { SplitSupplyBusiness } from "./split_supply_contract_model_pb";
import { file_bffuser_v1_split_supply_contract_model } from "./split_supply_contract_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/split_supply_plan_model.proto.
 */
export const file_bffuser_v1_split_supply_plan_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bffuser_v1_split_supply_contract_model, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date]);

/**
 * SplitSupplyNoticeKey identifies a 通 (the unit one OCCTO message carries). A
 * 通 is stored when it is created, with this natural key and no surrogate id:
 * 断面 × target date × area × sender × 負荷追随分供給者 × 負荷追随分の契約識別番号 1.
 * The key is frozen at creation; later master changes do not change it.
 *
 * @generated from message bffuser.v1.SplitSupplyNoticeKey
 */
export type SplitSupplyNoticeKey = Message<"bffuser.v1.SplitSupplyNoticeKey"> & {
  /**
   * @generated from field: bffuser.v1.SplitSupplyNoticeSection section = 1;
   */
  section: SplitSupplyNoticeSection;

  /**
   * The delivery date of a 翌日 通, any day of the month of a 月間 通.
   *
   * @generated from field: google.type.Date target_date = 2;
   */
  targetDate?: Date;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;

  /**
   * UUID of the business master of the sender (the own side).
   *
   * @generated from field: string own_business_master_id = 4;
   */
  ownBusinessMasterId: string;

  /**
   * UUID of the business master of the 負荷追随分供給者.
   *
   * @generated from field: string load_following_business_master_id = 5;
   */
  loadFollowingBusinessMasterId: string;

  /**
   * The 負荷追随分の契約識別番号 1.
   *
   * @generated from field: string load_following_contract_id = 6;
   */
  loadFollowingContractId: string;
};

/**
 * Describes the message bffuser.v1.SplitSupplyNoticeKey.
 * Use `create(SplitSupplyNoticeKeySchema)` to create a new message.
 */
export const SplitSupplyNoticeKeySchema: GenMessage<SplitSupplyNoticeKey> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_model, 0);

/**
 * SplitSupplyNoticePointSummary is a supply point of a 通 in the list.
 *
 * @generated from message bffuser.v1.SplitSupplyNoticePointSummary
 */
export type SplitSupplyNoticePointSummary = Message<"bffuser.v1.SplitSupplyNoticePointSummary"> & {
  /**
   * @generated from field: string supply_point_specific_number = 1;
   */
  supplyPointSpecificNumber: string;

  /**
   * 需要家 name in 顧客管理 when the 通 was created (not updated afterwards).
   *
   * @generated from field: string customer_name = 2;
   */
  customerName: string;
};

/**
 * Describes the message bffuser.v1.SplitSupplyNoticePointSummary.
 * Use `create(SplitSupplyNoticePointSummarySchema)` to create a new message.
 */
export const SplitSupplyNoticePointSummarySchema: GenMessage<SplitSupplyNoticePointSummary> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_model, 1);

/**
 * SplitSupplyNoticeListItem is a 通 in the list.
 *
 * @generated from message bffuser.v1.SplitSupplyNoticeListItem
 */
export type SplitSupplyNoticeListItem = Message<"bffuser.v1.SplitSupplyNoticeListItem"> & {
  /**
   * @generated from field: bffuser.v1.SplitSupplyNoticeKey key = 1;
   */
  key?: SplitSupplyNoticeKey;

  /**
   * The sender (自社の側の事業者).
   *
   * @generated from field: bffuser.v1.SplitSupplyBusiness own_business = 2;
   */
  ownBusiness?: SplitSupplyBusiness;

  /**
   * The 負荷追随分供給者.
   *
   * @generated from field: bffuser.v1.SplitSupplyBusiness load_following = 3;
   */
  loadFollowing?: SplitSupplyBusiness;

  /**
   * The supply points, ordered by supply point specific number.
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyNoticePointSummary points = 4;
   */
  points: SplitSupplyNoticePointSummary[];

  /**
   * The earliest creation and the latest update among the supply points.
   *
   * @generated from field: optional string created_by = 5;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional string updated_by = 7;
   */
  updatedBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.SplitSupplyNoticeListItem.
 * Use `create(SplitSupplyNoticeListItemSchema)` to create a new message.
 */
export const SplitSupplyNoticeListItemSchema: GenMessage<SplitSupplyNoticeListItem> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_model, 2);

/**
 * SplitSupplyNoticeSlot is a displayed slot of a delivery date.
 *
 * @generated from message bffuser.v1.SplitSupplyNoticeSlot
 */
export type SplitSupplyNoticeSlot = Message<"bffuser.v1.SplitSupplyNoticeSlot"> & {
  /**
   * Absent when blank.
   *
   * @generated from field: optional int64 value = 1;
   */
  value?: bigint;

  /**
   * @generated from field: bffuser.v1.SplitSupplyNoticeValueSource source = 2;
   */
  source: SplitSupplyNoticeValueSource;
};

/**
 * Describes the message bffuser.v1.SplitSupplyNoticeSlot.
 * Use `create(SplitSupplyNoticeSlotSchema)` to create a new message.
 */
export const SplitSupplyNoticeSlotSchema: GenMessage<SplitSupplyNoticeSlot> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_model, 3);

/**
 * SplitSupplyNoticeDay is the 48 slots of one delivery date.
 *
 * @generated from message bffuser.v1.SplitSupplyNoticeDay
 */
export type SplitSupplyNoticeDay = Message<"bffuser.v1.SplitSupplyNoticeDay"> & {
  /**
   * @generated from field: google.type.Date delivery_date = 1;
   */
  deliveryDate?: Date;

  /**
   * Exactly 48 slots, 00:00 first.
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyNoticeSlot slots = 2;
   */
  slots: SplitSupplyNoticeSlot[];
};

/**
 * Describes the message bffuser.v1.SplitSupplyNoticeDay.
 * Use `create(SplitSupplyNoticeDaySchema)` to create a new message.
 */
export const SplitSupplyNoticeDaySchema: GenMessage<SplitSupplyNoticeDay> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_model, 4);

/**
 * SplitSupplyNoticeDetailPoint is a supply point of a 通 with the 48 slots of
 * each shown delivery date.
 *
 * @generated from message bffuser.v1.SplitSupplyNoticeDetailPoint
 */
export type SplitSupplyNoticeDetailPoint = Message<"bffuser.v1.SplitSupplyNoticeDetailPoint"> & {
  /**
   * @generated from field: string supply_point_specific_number = 1;
   */
  supplyPointSpecificNumber: string;

  /**
   * @generated from field: string customer_name = 2;
   */
  customerName: string;

  /**
   * The ベース分供給者 of the contract when the 通 was created (not updated afterwards).
   *
   * @generated from field: bffuser.v1.SplitSupplyBusiness base = 3;
   */
  base?: SplitSupplyBusiness;

  /**
   * @generated from field: string base_contract_id = 4;
   */
  baseContractId: string;

  /**
   * @generated from field: optional int32 base_priority = 5;
   */
  basePriority?: number;

  /**
   * The shown delivery dates, oldest first (the same dates for every point).
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyNoticeDay days = 6;
   */
  days: SplitSupplyNoticeDay[];

  /**
   * The optimistic-lock baseline of the record (the save sends it back).
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.SplitSupplyNoticeDetailPoint.
 * Use `create(SplitSupplyNoticeDetailPointSchema)` to create a new message.
 */
export const SplitSupplyNoticeDetailPointSchema: GenMessage<SplitSupplyNoticeDetailPoint> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_model, 5);

/**
 * SplitSupplyNoticeDayInput is the 48 slots of one delivery date of a save. The
 * slots are sent as the numbers of the slots that have a value and the numbers
 * of the blank slots, so that a request is a few packed arrays, not 48
 * messages. values.length + blank_slots.length must be 48. A value is int32 so
 * that a request has a bounded size; the domain checks the range of a value (0
 * to 999999999) so that an API caller gets the same reason as the screen.
 *
 * @generated from message bffuser.v1.SplitSupplyNoticeDayInput
 */
export type SplitSupplyNoticeDayInput = Message<"bffuser.v1.SplitSupplyNoticeDayInput"> & {
  /**
   * @generated from field: google.type.Date delivery_date = 1;
   */
  deliveryDate?: Date;

  /**
   * The values of the slots that have one, in slot order (00:00 first).
   *
   * @generated from field: repeated int32 values = 2;
   */
  values: number[];

  /**
   * The slot numbers (0 = 00:00 ... 47 = 23:30) that are 空欄, each once.
   *
   * @generated from field: repeated int32 blank_slots = 3;
   */
  blankSlots: number[];
};

/**
 * Describes the message bffuser.v1.SplitSupplyNoticeDayInput.
 * Use `create(SplitSupplyNoticeDayInputSchema)` to create a new message.
 */
export const SplitSupplyNoticeDayInputSchema: GenMessage<SplitSupplyNoticeDayInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_model, 6);

/**
 * SplitSupplyNoticePointInput is a supply point of a save.
 *
 * @generated from message bffuser.v1.SplitSupplyNoticePointInput
 */
export type SplitSupplyNoticePointInput = Message<"bffuser.v1.SplitSupplyNoticePointInput"> & {
  /**
   * @generated from field: string supply_point_specific_number = 1;
   */
  supplyPointSpecificNumber: string;

  /**
   * The delivery dates saved: one day, or up to a whole month. Every point
   * carries the same dates; the days not given keep their stored values.
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyNoticeDayInput days = 2;
   */
  days: SplitSupplyNoticeDayInput[];

  /**
   * The updated_at the caller read for this supply point.
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 3;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.SplitSupplyNoticePointInput.
 * Use `create(SplitSupplyNoticePointInputSchema)` to create a new message.
 */
export const SplitSupplyNoticePointInputSchema: GenMessage<SplitSupplyNoticePointInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_model, 7);

/**
 * SplitSupplyPartnerNoticeListItem is a 他社の通告値 registration in the list: one
 * registration is one row.
 *
 * @generated from message bffuser.v1.SplitSupplyPartnerNoticeListItem
 */
export type SplitSupplyPartnerNoticeListItem = Message<"bffuser.v1.SplitSupplyPartnerNoticeListItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bffuser.v1.SplitSupplyNoticeSection section = 2;
   */
  section: SplitSupplyNoticeSection;

  /**
   * The delivery date of a 翌日 registration, the first of the month of a 月間 one.
   *
   * @generated from field: google.type.Date target_date = 3;
   */
  targetDate?: Date;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 4;
   */
  areaCode: AreaCode;

  /**
   * The company that gave the values, as copied at registration.
   *
   * @generated from field: string counterparty_business_code = 5;
   */
  counterpartyBusinessCode: string;

  /**
   * @generated from field: string counterparty_business_name = 6;
   */
  counterpartyBusinessName: string;

  /**
   * The supply points, ordered by supply point specific number.
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyNoticePointSummary points = 7;
   */
  points: SplitSupplyNoticePointSummary[];

  /**
   * The registration (登録日時・登録者).
   *
   * @generated from field: optional string created_by = 8;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: bffuser.v1.SplitSupplyPartnerNoticeChannel channel = 10;
   */
  channel: SplitSupplyPartnerNoticeChannel;

  /**
   * @generated from field: string source_file_name = 11;
   */
  sourceFileName: string;
};

/**
 * Describes the message bffuser.v1.SplitSupplyPartnerNoticeListItem.
 * Use `create(SplitSupplyPartnerNoticeListItemSchema)` to create a new message.
 */
export const SplitSupplyPartnerNoticeListItemSchema: GenMessage<SplitSupplyPartnerNoticeListItem> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_model, 8);

/**
 * SplitSupplyPartnerNoticeAreaOption is the companies to register a 他社の通告値
 * for in one area: the other side of the 変動型 contracts of the area whose
 * 通告値 they submit.
 *
 * @generated from message bffuser.v1.SplitSupplyPartnerNoticeAreaOption
 */
export type SplitSupplyPartnerNoticeAreaOption = Message<"bffuser.v1.SplitSupplyPartnerNoticeAreaOption"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: repeated bffuser.v1.SplitSupplyBusiness partners = 2;
   */
  partners: SplitSupplyBusiness[];
};

/**
 * Describes the message bffuser.v1.SplitSupplyPartnerNoticeAreaOption.
 * Use `create(SplitSupplyPartnerNoticeAreaOptionSchema)` to create a new message.
 */
export const SplitSupplyPartnerNoticeAreaOptionSchema: GenMessage<SplitSupplyPartnerNoticeAreaOption> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_model, 9);

/**
 * SplitSupplyPartnerNoticeDetailPoint is a supply point of a 他社の通告値
 * registration with the 48 slots of each shown delivery date.
 *
 * @generated from message bffuser.v1.SplitSupplyPartnerNoticeDetailPoint
 */
export type SplitSupplyPartnerNoticeDetailPoint = Message<"bffuser.v1.SplitSupplyPartnerNoticeDetailPoint"> & {
  /**
   * @generated from field: string supply_point_specific_number = 1;
   */
  supplyPointSpecificNumber: string;

  /**
   * @generated from field: string customer_name = 2;
   */
  customerName: string;

  /**
   * The shown delivery dates, oldest first (the same dates for every point).
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyNoticeDay days = 3;
   */
  days: SplitSupplyNoticeDay[];

  /**
   * The ベース分 of the contract copied at registration (later contract or master
   * changes do not reach it). Unset for a registration made before the copy
   * was kept.
   *
   * @generated from field: bffuser.v1.SplitSupplyBusiness base = 4;
   */
  base?: SplitSupplyBusiness;

  /**
   * @generated from field: optional string base_contract_id = 5;
   */
  baseContractId?: string;

  /**
   * @generated from field: optional int32 base_priority = 6;
   */
  basePriority?: number;
};

/**
 * Describes the message bffuser.v1.SplitSupplyPartnerNoticeDetailPoint.
 * Use `create(SplitSupplyPartnerNoticeDetailPointSchema)` to create a new message.
 */
export const SplitSupplyPartnerNoticeDetailPointSchema: GenMessage<SplitSupplyPartnerNoticeDetailPoint> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_model, 10);

/**
 * SplitSupplyPartnerNoticePointInput is a supply point of a save of a 他社の通告値.
 *
 * @generated from message bffuser.v1.SplitSupplyPartnerNoticePointInput
 */
export type SplitSupplyPartnerNoticePointInput = Message<"bffuser.v1.SplitSupplyPartnerNoticePointInput"> & {
  /**
   * @generated from field: string supply_point_specific_number = 1;
   */
  supplyPointSpecificNumber: string;

  /**
   * The delivery dates saved: one day, or up to a whole month. Every point
   * carries the same dates; the days not given keep their stored values.
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyNoticeDayInput days = 2;
   */
  days: SplitSupplyNoticeDayInput[];
};

/**
 * Describes the message bffuser.v1.SplitSupplyPartnerNoticePointInput.
 * Use `create(SplitSupplyPartnerNoticePointInputSchema)` to create a new message.
 */
export const SplitSupplyPartnerNoticePointInputSchema: GenMessage<SplitSupplyPartnerNoticePointInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_model, 11);

/**
 * SplitSupplyPartnerNoticeImportItem is a 通 an import would register: the
 * confirmation shows one row of it.
 *
 * @generated from message bffuser.v1.SplitSupplyPartnerNoticeImportItem
 */
export type SplitSupplyPartnerNoticeImportItem = Message<"bffuser.v1.SplitSupplyPartnerNoticeImportItem"> & {
  /**
   * @generated from field: bffuser.v1.SplitSupplyNoticeSection section = 1;
   */
  section: SplitSupplyNoticeSection;

  /**
   * The delivery date of a 翌日 通, the first of the month of a 月間 one.
   *
   * @generated from field: google.type.Date target_date = 2;
   */
  targetDate?: Date;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: string counterparty_business_code = 4;
   */
  counterpartyBusinessCode: string;

  /**
   * @generated from field: string counterparty_business_name = 5;
   */
  counterpartyBusinessName: string;

  /**
   * @generated from field: bffuser.v1.SplitSupplyPartnerNoticeImportKind kind = 6;
   */
  kind: SplitSupplyPartnerNoticeImportKind;

  /**
   * The supply points the 通 will have.
   *
   * @generated from field: int32 point_count = 7;
   */
  pointCount: number;

  /**
   * The supply points of the contracts of this company and area that neither the
   * files nor the registration carry; the first 100 are listed.
   *
   * @generated from field: int32 missing_contract_point_count = 8;
   */
  missingContractPointCount: number;

  /**
   * @generated from field: repeated string missing_contract_points = 9;
   */
  missingContractPoints: string[];

  /**
   * Whether the 通 is past by date (today or earlier): its values do not reach
   * actuals already imported.
   *
   * @generated from field: bool past = 12;
   */
  past: boolean;

  /**
   * The files the 通 is made of.
   *
   * @generated from field: repeated string source_files = 13;
   */
  sourceFiles: string[];
};

/**
 * Describes the message bffuser.v1.SplitSupplyPartnerNoticeImportItem.
 * Use `create(SplitSupplyPartnerNoticeImportItemSchema)` to create a new message.
 */
export const SplitSupplyPartnerNoticeImportItemSchema: GenMessage<SplitSupplyPartnerNoticeImportItem> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_model, 12);

/**
 * SplitSupplyPartnerNoticeSkippedPoint is a supply point left out of an import.
 *
 * @generated from message bffuser.v1.SplitSupplyPartnerNoticeSkippedPoint
 */
export type SplitSupplyPartnerNoticeSkippedPoint = Message<"bffuser.v1.SplitSupplyPartnerNoticeSkippedPoint"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: string supply_point_number = 2;
   */
  supplyPointNumber: string;

  /**
   * @generated from field: bffuser.v1.SplitSupplyPartnerNoticeSkipReason reason = 3;
   */
  reason: SplitSupplyPartnerNoticeSkipReason;
};

/**
 * Describes the message bffuser.v1.SplitSupplyPartnerNoticeSkippedPoint.
 * Use `create(SplitSupplyPartnerNoticeSkippedPointSchema)` to create a new message.
 */
export const SplitSupplyPartnerNoticeSkippedPointSchema: GenMessage<SplitSupplyPartnerNoticeSkippedPoint> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_model, 13);

/**
 * SplitSupplyPartnerNoticeSkipCount is how many supply points were skipped for a reason.
 *
 * @generated from message bffuser.v1.SplitSupplyPartnerNoticeSkipCount
 */
export type SplitSupplyPartnerNoticeSkipCount = Message<"bffuser.v1.SplitSupplyPartnerNoticeSkipCount"> & {
  /**
   * @generated from field: bffuser.v1.SplitSupplyPartnerNoticeSkipReason reason = 1;
   */
  reason: SplitSupplyPartnerNoticeSkipReason;

  /**
   * @generated from field: int32 count = 2;
   */
  count: number;
};

/**
 * Describes the message bffuser.v1.SplitSupplyPartnerNoticeSkipCount.
 * Use `create(SplitSupplyPartnerNoticeSkipCountSchema)` to create a new message.
 */
export const SplitSupplyPartnerNoticeSkipCountSchema: GenMessage<SplitSupplyPartnerNoticeSkipCount> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_model, 14);

/**
 * SplitSupplyPartnerNoticeImportError is an error of the uploaded files and where it is.
 *
 * @generated from message bffuser.v1.SplitSupplyPartnerNoticeImportError
 */
export type SplitSupplyPartnerNoticeImportError = Message<"bffuser.v1.SplitSupplyPartnerNoticeImportError"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: optional string supply_point_number = 2;
   */
  supplyPointNumber?: string;

  /**
   * @generated from field: optional google.type.Date date = 3;
   */
  date?: Date;

  /**
   * The slot, 1 to 48.
   *
   * @generated from field: optional int32 slot = 4;
   */
  slot?: number;

  /**
   * @generated from field: bffuser.v1.SplitSupplyPartnerNoticeImportIssueReason reason = 5;
   */
  reason: SplitSupplyPartnerNoticeImportIssueReason;
};

/**
 * Describes the message bffuser.v1.SplitSupplyPartnerNoticeImportError.
 * Use `create(SplitSupplyPartnerNoticeImportErrorSchema)` to create a new message.
 */
export const SplitSupplyPartnerNoticeImportErrorSchema: GenMessage<SplitSupplyPartnerNoticeImportError> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_model, 15);

/**
 * SplitSupplyOwnNoticeImportPoint is a supply point a 自社の通告値 import writes.
 *
 * @generated from message bffuser.v1.SplitSupplyOwnNoticeImportPoint
 */
export type SplitSupplyOwnNoticeImportPoint = Message<"bffuser.v1.SplitSupplyOwnNoticeImportPoint"> & {
  /**
   * @generated from field: string supply_point_specific_number = 1;
   */
  supplyPointSpecificNumber: string;

  /**
   * 需要家 name in 顧客管理.
   *
   * @generated from field: string customer_name = 2;
   */
  customerName: string;

  /**
   * @generated from field: bffuser.v1.SplitSupplyOwnNoticeImportPointKind kind = 3;
   */
  kind: SplitSupplyOwnNoticeImportPointKind;
};

/**
 * Describes the message bffuser.v1.SplitSupplyOwnNoticeImportPoint.
 * Use `create(SplitSupplyOwnNoticeImportPointSchema)` to create a new message.
 */
export const SplitSupplyOwnNoticeImportPointSchema: GenMessage<SplitSupplyOwnNoticeImportPoint> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_model, 16);

/**
 * SplitSupplyOwnNoticeImportItem is a 通 a 自社の通告値 import would write: the
 * confirmation shows one row of it.
 *
 * @generated from message bffuser.v1.SplitSupplyOwnNoticeImportItem
 */
export type SplitSupplyOwnNoticeImportItem = Message<"bffuser.v1.SplitSupplyOwnNoticeImportItem"> & {
  /**
   * @generated from field: bffuser.v1.SplitSupplyNoticeSection section = 1;
   */
  section: SplitSupplyNoticeSection;

  /**
   * The delivery date of a 翌日 通, the first of the month of a 月間 one.
   *
   * @generated from field: google.type.Date target_date = 2;
   */
  targetDate?: Date;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;

  /**
   * The sender (自社の側の事業者).
   *
   * @generated from field: bffuser.v1.SplitSupplyBusiness own_business = 4;
   */
  ownBusiness?: SplitSupplyBusiness;

  /**
   * The 負荷追随分供給者 and its 契約識別番号 1.
   *
   * @generated from field: bffuser.v1.SplitSupplyBusiness load_following = 5;
   */
  loadFollowing?: SplitSupplyBusiness;

  /**
   * @generated from field: string load_following_contract_id = 6;
   */
  loadFollowingContractId: string;

  /**
   * Supply points created now / overwritten.
   *
   * @generated from field: int32 new_point_count = 7;
   */
  newPointCount: number;

  /**
   * @generated from field: int32 overwrite_point_count = 8;
   */
  overwritePointCount: number;

  /**
   * The days the files carry for the 通, after the days with every slot empty
   * are left out (the union over its supply points).
   *
   * @generated from field: int32 day_count = 9;
   */
  dayCount: number;

  /**
   * Overwritten supply points that have days of the period the files do not
   * carry (those days keep their values).
   *
   * @generated from field: int32 overwrite_with_absent_days_count = 10;
   */
  overwriteWithAbsentDaysCount: number;

  /**
   * (supply point, day) pairs with every slot empty that are not imported.
   *
   * @generated from field: int32 blank_day_count = 11;
   */
  blankDayCount: number;

  /**
   * The supply points the 通 writes; the first 100.
   *
   * @generated from field: repeated bffuser.v1.SplitSupplyOwnNoticeImportPoint points = 12;
   */
  points: SplitSupplyOwnNoticeImportPoint[];
};

/**
 * Describes the message bffuser.v1.SplitSupplyOwnNoticeImportItem.
 * Use `create(SplitSupplyOwnNoticeImportItemSchema)` to create a new message.
 */
export const SplitSupplyOwnNoticeImportItemSchema: GenMessage<SplitSupplyOwnNoticeImportItem> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_model, 17);

/**
 * SplitSupplyOwnNoticeSkippedPoint is a supply point left out of an import.
 *
 * @generated from message bffuser.v1.SplitSupplyOwnNoticeSkippedPoint
 */
export type SplitSupplyOwnNoticeSkippedPoint = Message<"bffuser.v1.SplitSupplyOwnNoticeSkippedPoint"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: string supply_point_number = 2;
   */
  supplyPointNumber: string;

  /**
   * @generated from field: bffuser.v1.SplitSupplyOwnNoticeSkipReason reason = 3;
   */
  reason: SplitSupplyOwnNoticeSkipReason;
};

/**
 * Describes the message bffuser.v1.SplitSupplyOwnNoticeSkippedPoint.
 * Use `create(SplitSupplyOwnNoticeSkippedPointSchema)` to create a new message.
 */
export const SplitSupplyOwnNoticeSkippedPointSchema: GenMessage<SplitSupplyOwnNoticeSkippedPoint> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_model, 18);

/**
 * SplitSupplyOwnNoticeSkipCount is how many supply points were skipped for a reason.
 *
 * @generated from message bffuser.v1.SplitSupplyOwnNoticeSkipCount
 */
export type SplitSupplyOwnNoticeSkipCount = Message<"bffuser.v1.SplitSupplyOwnNoticeSkipCount"> & {
  /**
   * @generated from field: bffuser.v1.SplitSupplyOwnNoticeSkipReason reason = 1;
   */
  reason: SplitSupplyOwnNoticeSkipReason;

  /**
   * @generated from field: int32 count = 2;
   */
  count: number;
};

/**
 * Describes the message bffuser.v1.SplitSupplyOwnNoticeSkipCount.
 * Use `create(SplitSupplyOwnNoticeSkipCountSchema)` to create a new message.
 */
export const SplitSupplyOwnNoticeSkipCountSchema: GenMessage<SplitSupplyOwnNoticeSkipCount> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_model, 19);

/**
 * SplitSupplyOwnNoticeBlankPoint is a supply point of the files with every slot of
 * every day empty (a blank CSV column, an XML point without rows): it is not
 * imported and its 通告値 is not touched.
 *
 * @generated from message bffuser.v1.SplitSupplyOwnNoticeBlankPoint
 */
export type SplitSupplyOwnNoticeBlankPoint = Message<"bffuser.v1.SplitSupplyOwnNoticeBlankPoint"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: string supply_point_number = 2;
   */
  supplyPointNumber: string;
};

/**
 * Describes the message bffuser.v1.SplitSupplyOwnNoticeBlankPoint.
 * Use `create(SplitSupplyOwnNoticeBlankPointSchema)` to create a new message.
 */
export const SplitSupplyOwnNoticeBlankPointSchema: GenMessage<SplitSupplyOwnNoticeBlankPoint> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_plan_model, 20);

/**
 * SplitSupplyNoticeSection mirrors internalapi.v1.SplitSupplyNoticeSection 1:1.
 *
 * @generated from enum bffuser.v1.SplitSupplyNoticeSection
 */
export enum SplitSupplyNoticeSection {
  /**
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_SECTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 翌日 (OCCTO 情報区分 0610). The target date is the delivery date.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_SECTION_DAY_AHEAD = 1;
   */
  DAY_AHEAD = 1,

  /**
   * 月間 (OCCTO 情報区分 0620). The target date is any day of the month.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_SECTION_MONTHLY = 2;
   */
  MONTHLY = 2,
}

/**
 * Describes the enum bffuser.v1.SplitSupplyNoticeSection.
 */
export const SplitSupplyNoticeSectionSchema: GenEnum<SplitSupplyNoticeSection> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_split_supply_plan_model, 0);

/**
 * SplitSupplyNoticeValueSource says whether a displayed slot has a value. The
 * values of every day are stored when the 通告値 is created (the 基本パターン's
 * value, or none where no pattern applies) and are shown as they are stored.
 *
 * @generated from enum bffuser.v1.SplitSupplyNoticeValueSource
 */
export enum SplitSupplyNoticeValueSource {
  /**
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_VALUE_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * A stored value: the one the 基本パターン gave when the 通告値 was created, or
   * the one the user typed later.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_VALUE_SOURCE_SAVED = 1;
   */
  SAVED = 1,

  /**
   * No value (空欄): stored as empty, and not filled in again when it is read.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_VALUE_SOURCE_BLANK = 2;
   */
  BLANK = 2,
}

/**
 * Describes the enum bffuser.v1.SplitSupplyNoticeValueSource.
 */
export const SplitSupplyNoticeValueSourceSchema: GenEnum<SplitSupplyNoticeValueSource> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_split_supply_plan_model, 1);

/**
 * SplitSupplyNoticeNotEditableReason says why a 通 cannot be edited.
 *
 * @generated from enum bffuser.v1.SplitSupplyNoticeNotEditableReason
 */
export enum SplitSupplyNoticeNotEditableReason {
  /**
   * The 通 is editable.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_NOT_EDITABLE_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The 通 is past: a 翌日 通 whose delivery date is today or earlier, a 月間 通
   * whose month is this month or earlier.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_NOT_EDITABLE_REASON_DATE_CLOSED = 1;
   */
  DATE_CLOSED = 1,
}

/**
 * Describes the enum bffuser.v1.SplitSupplyNoticeNotEditableReason.
 */
export const SplitSupplyNoticeNotEditableReasonSchema: GenEnum<SplitSupplyNoticeNotEditableReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_split_supply_plan_model, 2);

/**
 * SplitSupplyNoticeDownloadFormat is the format of an XML download.
 *
 * @generated from enum bffuser.v1.SplitSupplyNoticeDownloadFormat
 */
export enum SplitSupplyNoticeDownloadFormat {
  /**
   * Automatic: a plain XML for a 通 of at most 100 supply points, a ZIP of
   * 100-point files above that.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_DOWNLOAD_FORMAT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * A plain XML. Rejected (XML_SPLIT_REQUIRED) for a 通 of more than 100 points.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_DOWNLOAD_FORMAT_XML = 1;
   */
  XML = 1,

  /**
   * A ZIP of the XML file(s).
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_DOWNLOAD_FORMAT_ZIP = 2;
   */
  ZIP = 2,
}

/**
 * Describes the enum bffuser.v1.SplitSupplyNoticeDownloadFormat.
 */
export const SplitSupplyNoticeDownloadFormatSchema: GenEnum<SplitSupplyNoticeDownloadFormat> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_split_supply_plan_model, 3);

/**
 * SplitSupplyNoticeErrorReason mirrors internalapi.v1.SplitSupplyNoticeErrorReason
 * 1:1. Attached to the Connect error of a rejected 自社の通告値 request.
 *
 * @generated from enum bffuser.v1.SplitSupplyNoticeErrorReason
 */
export enum SplitSupplyNoticeErrorReason {
  /**
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The 通 is past (see SplitSupplyNoticeNotEditableReason): it cannot be
   * created or edited.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_ERROR_REASON_NOTICE_DATE_CLOSED = 1;
   */
  NOTICE_DATE_CLOSED = 1,

  /**
   * The supply points of the 通 differ from the ones the save carries.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_ERROR_REASON_NOTICE_POINTS_CHANGED = 2;
   */
  NOTICE_POINTS_CHANGED = 2,

  /**
   * No 通 matches the key.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_ERROR_REASON_NOTICE_NOT_FOUND = 3;
   */
  NOTICE_NOT_FOUND = 3,

  /**
   * A slot value is not an integer from 0 to 999999999.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_ERROR_REASON_NOTICE_VALUE_OUT_OF_RANGE = 4;
   */
  NOTICE_VALUE_OUT_OF_RANGE = 4,

  /**
   * The delivery date is outside the period of the 通.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_ERROR_REASON_NOTICE_DELIVERY_DATE_OUT_OF_PERIOD = 5;
   */
  NOTICE_DELIVERY_DATE_OUT_OF_PERIOD = 5,

  /**
   * A plain XML was asked for a 通 of more than 100 supply points.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_ERROR_REASON_XML_SPLIT_REQUIRED = 6;
   */
  XML_SPLIT_REQUIRED = 6,

  /**
   * Creating would make a 通 of more than 1000 supply points, more than a save
   * can carry (SaveOwnSplitSupplyNoticeValuesRequest.points max_items). Nothing
   * is created.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_ERROR_REASON_NOTICE_TOO_MANY_POINTS = 7;
   */
  NOTICE_TOO_MANY_POINTS = 7,

  /**
   * No 他社の通告値 registration matches the id.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_ERROR_REASON_PARTNER_NOTICE_NOT_FOUND = 8;
   */
  PARTNER_NOTICE_NOT_FOUND = 8,

  /**
   * No supply point has a contract in which the chosen company submits the
   * 通告値 in the area. Nothing is registered.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_ERROR_REASON_PARTNER_NOTICE_NO_POINTS = 9;
   */
  PARTNER_NOTICE_NO_POINTS = 9,

  /**
   * The supply points of the 他社の通告値 registration differ from the ones the
   * save carries.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_ERROR_REASON_PARTNER_NOTICE_POINTS_CHANGED = 10;
   */
  PARTNER_NOTICE_POINTS_CHANGED = 10,

  /**
   * The days a save carries are empty, repeated, or differ between the supply
   * points (every point carries the same, non-empty set of days).
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_ERROR_REASON_NOTICE_DAYS_INVALID = 11;
   */
  NOTICE_DAYS_INVALID = 11,

  /**
   * An uploaded file of a 他社の通告値 import cannot be used: no such upload
   * token, it expired, it was used already, it belongs to another organization
   * or to another kind of upload. The caller selects the files again.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_ERROR_REASON_PARTNER_NOTICE_IMPORT_UPLOAD_EXPIRED = 12;
   */
  PARTNER_NOTICE_IMPORT_UPLOAD_EXPIRED = 12,

  /**
   * The files have errors (see SplitSupplyPartnerNoticeImportIssueReason), so
   * nothing is imported. Returned by ImportPartnerSplitSupplyNotices; the preview
   * carries the errors in its response.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_ERROR_REASON_PARTNER_NOTICE_IMPORT_INVALID = 13;
   */
  PARTNER_NOTICE_IMPORT_INVALID = 13,

  /**
   * No supply point of the files can be imported (every one is skipped). Returned
   * by ImportPartnerSplitSupplyNotices; the preview sets nothing.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_ERROR_REASON_PARTNER_NOTICE_IMPORT_NOTHING = 14;
   */
  PARTNER_NOTICE_IMPORT_NOTHING = 14,

  /**
   * What the files would import differs from what the confirmation showed (a
   * file, a contract or a registration changed since). Nothing is imported; the
   * caller confirms again.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_ERROR_REASON_PARTNER_NOTICE_IMPORT_CHANGED = 15;
   */
  PARTNER_NOTICE_IMPORT_CHANGED = 15,

  /**
   * The files exceed a limit (the number of files, the size of a file or of all
   * of them once inflated, a ZIP compressing too far). Returned by
   * ImportPartnerSplitSupplyNotices; the preview sets too_large.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_ERROR_REASON_PARTNER_NOTICE_IMPORT_TOO_LARGE = 16;
   */
  PARTNER_NOTICE_IMPORT_TOO_LARGE = 16,

  /**
   * An uploaded file of a 自社の通告値 import cannot be used (the same meaning as
   * PARTNER_NOTICE_IMPORT_UPLOAD_EXPIRED, for the own side's import).
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_ERROR_REASON_OWN_NOTICE_IMPORT_UPLOAD_EXPIRED = 17;
   */
  OWN_NOTICE_IMPORT_UPLOAD_EXPIRED = 17,

  /**
   * The files of a 自社の通告値 import have errors; nothing is imported.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_ERROR_REASON_OWN_NOTICE_IMPORT_INVALID = 18;
   */
  OWN_NOTICE_IMPORT_INVALID = 18,

  /**
   * No supply point of the files of a 自社の通告値 import can be imported.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_ERROR_REASON_OWN_NOTICE_IMPORT_NOTHING = 19;
   */
  OWN_NOTICE_IMPORT_NOTHING = 19,

  /**
   * What a 自社の通告値 import would write differs from what the confirmation
   * showed; nothing is imported and the caller confirms again.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_ERROR_REASON_OWN_NOTICE_IMPORT_CHANGED = 20;
   */
  OWN_NOTICE_IMPORT_CHANGED = 20,

  /**
   * The files of a 自社の通告値 import exceed a limit.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_ERROR_REASON_OWN_NOTICE_IMPORT_TOO_LARGE = 21;
   */
  OWN_NOTICE_IMPORT_TOO_LARGE = 21,

  /**
   * No supply point has a 変動型 contract in which the own side submits the
   * 通告値 on the day: there is nothing to put in the CSV template.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_ERROR_REASON_OWN_NOTICE_TEMPLATE_NO_POINTS = 22;
   */
  OWN_NOTICE_TEMPLATE_NO_POINTS = 22,
}

/**
 * Describes the enum bffuser.v1.SplitSupplyNoticeErrorReason.
 */
export const SplitSupplyNoticeErrorReasonSchema: GenEnum<SplitSupplyNoticeErrorReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_split_supply_plan_model, 4);

/**
 * SplitSupplyPartnerNoticeChannel is how a 他社の通告値 reached eBalance.
 *
 * @generated from enum bffuser.v1.SplitSupplyPartnerNoticeChannel
 */
export enum SplitSupplyPartnerNoticeChannel {
  /**
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_CHANNEL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * An OCCTO XML (0610 / 0620) the other company sent.
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_CHANNEL_XML = 1;
   */
  XML = 1,

  /**
   * A CSV file.
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_CHANNEL_CSV = 2;
   */
  CSV = 2,

  /**
   * Typed in on the screen.
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_CHANNEL_MANUAL = 3;
   */
  MANUAL = 3,
}

/**
 * Describes the enum bffuser.v1.SplitSupplyPartnerNoticeChannel.
 */
export const SplitSupplyPartnerNoticeChannelSchema: GenEnum<SplitSupplyPartnerNoticeChannel> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_split_supply_plan_model, 5);

/**
 * How far the values of a 他社の通告値 registration are entered, over the whole
 * period.
 *
 * @generated from enum bffuser.v1.SplitSupplyPartnerNoticeFillState
 */
export enum SplitSupplyPartnerNoticeFillState {
  /**
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_FILL_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * No value has been saved yet (未入力).
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_FILL_STATE_EMPTY = 1;
   */
  EMPTY = 1,

  /**
   * Some slots of some supply point x day are still blank (入力中).
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_FILL_STATE_PARTIAL = 2;
   */
  PARTIAL = 2,

  /**
   * Every slot of every supply point x day of the period holds a value (入力済).
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_FILL_STATE_COMPLETE = 3;
   */
  COMPLETE = 3,
}

/**
 * Describes the enum bffuser.v1.SplitSupplyPartnerNoticeFillState.
 */
export const SplitSupplyPartnerNoticeFillStateSchema: GenEnum<SplitSupplyPartnerNoticeFillState> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_split_supply_plan_model, 6);

/**
 * SplitSupplyPartnerNoticeImportKind says whether an import registers a 通 for
 * the first time or replaces the registration that exists.
 *
 * @generated from enum bffuser.v1.SplitSupplyPartnerNoticeImportKind
 */
export enum SplitSupplyPartnerNoticeImportKind {
  /**
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_IMPORT_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_IMPORT_KIND_NEW = 1;
   */
  NEW = 1,

  /**
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_IMPORT_KIND_REPLACE = 2;
   */
  REPLACE = 2,
}

/**
 * Describes the enum bffuser.v1.SplitSupplyPartnerNoticeImportKind.
 */
export const SplitSupplyPartnerNoticeImportKindSchema: GenEnum<SplitSupplyPartnerNoticeImportKind> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_split_supply_plan_model, 7);

/**
 * SplitSupplyPartnerNoticeSkipReason is why a supply point of the files is left
 * out of an import (it is not an error). The screen words every reason that
 * makes the point not a point to register the same way.
 *
 * @generated from enum bffuser.v1.SplitSupplyPartnerNoticeSkipReason
 */
export enum SplitSupplyPartnerNoticeSkipReason {
  /**
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_SKIP_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Not a point to register the other company's 通告値 for: no 変動型 contract
   * of the delivery date, the own side gives the 通告値, the sender of the XML is
   * not the other company of the contract, or the area of the file's 提出先 is
   * not the area of the point (which does not happen normally).
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_SKIP_REASON_NOT_ELIGIBLE = 1;
   */
  NOT_ELIGIBLE = 1,

  /**
   * The same supply point is in more than one message of the same ZIP for the same
   * 通 (断面 x 対象日 x エリア x 他社); it is left out of that 通 alone.
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_SKIP_REASON_DUPLICATE_IN_ZIP = 2;
   */
  DUPLICATE_IN_ZIP = 2,

  /**
   * Neither the 負荷追随分供給者 nor any ベース分供給者 of the XML message is the own
   * company: the message is not registered (each of its supply points is listed).
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_SKIP_REASON_NOT_PARTY = 3;
   */
  NOT_PARTY = 3,
}

/**
 * Describes the enum bffuser.v1.SplitSupplyPartnerNoticeSkipReason.
 */
export const SplitSupplyPartnerNoticeSkipReasonSchema: GenEnum<SplitSupplyPartnerNoticeSkipReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_split_supply_plan_model, 8);

/**
 * SplitSupplyPartnerNoticeImportIssueReason is an error of the uploaded files.
 *
 * @generated from enum bffuser.v1.SplitSupplyPartnerNoticeImportIssueReason
 */
export enum SplitSupplyPartnerNoticeImportIssueReason {
  /**
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_IMPORT_ISSUE_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Neither XML, CSV nor ZIP.
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_IMPORT_ISSUE_REASON_UNSUPPORTED_FORMAT = 1;
   */
  UNSUPPORTED_FORMAT = 1,

  /**
   * A ZIP inside a ZIP.
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_IMPORT_ISSUE_REASON_NESTED_ZIP = 2;
   */
  NESTED_ZIP = 2,

  /**
   * The file cannot be read (broken ZIP, broken XML, a DOCTYPE).
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_IMPORT_ISSUE_REASON_BROKEN_FILE = 3;
   */
  BROKEN_FILE = 3,

  /**
   * The character encoding is not UTF-8 or Shift_JIS.
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_IMPORT_ISSUE_REASON_UNSUPPORTED_ENCODING = 4;
   */
  UNSUPPORTED_ENCODING = 4,

  /**
   * An XML that is not a 0610 / 0620 message, or lacks what it needs.
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_IMPORT_ISSUE_REASON_UNSUPPORTED_MESSAGE = 5;
   */
  UNSUPPORTED_MESSAGE = 5,

  /**
   * The file's 断面 (0610 = 翌日, 0620 = 月間) is not the tab's.
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_IMPORT_ISSUE_REASON_SECTION_MISMATCH = 6;
   */
  SECTION_MISMATCH = 6,

  /**
   * The 提出先事業者コード is not an area's.
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_IMPORT_ISSUE_REASON_UNKNOWN_DESTINATION = 7;
   */
  UNKNOWN_DESTINATION = 7,

  /**
   * A date that is not a date.
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_IMPORT_ISSUE_REASON_INVALID_DATE = 8;
   */
  INVALID_DATE = 8,

  /**
   * A slot that is not 1 to 48.
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_IMPORT_ISSUE_REASON_INVALID_SLOT = 9;
   */
  INVALID_SLOT = 9,

  /**
   * A value that is not an integer (negative, decimal, not a number).
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_IMPORT_ISSUE_REASON_VALUE_INVALID = 10;
   */
  VALUE_INVALID = 10,

  /**
   * A value above 999,999,999.
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_IMPORT_ISSUE_REASON_VALUE_OUT_OF_RANGE = 11;
   */
  VALUE_OUT_OF_RANGE = 11,

  /**
   * A day of a CSV does not carry all 48 slots.
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_IMPORT_ISSUE_REASON_SLOT_COUNT = 12;
   */
  SLOT_COUNT = 12,

  /**
   * The same supply point x day x slot twice.
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_IMPORT_ISSUE_REASON_DUPLICATE_SLOT = 13;
   */
  DUPLICATE_SLOT = 13,

  /**
   * The same supply point twice in a 通.
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_IMPORT_ISSUE_REASON_DUPLICATE_POINT = 14;
   */
  DUPLICATE_POINT = 14,

  /**
   * A day outside the period of the tab (a day other than the 翌日's, another month).
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_IMPORT_ISSUE_REASON_DATE_OUT_OF_PERIOD = 15;
   */
  DATE_OUT_OF_PERIOD = 15,

  /**
   * The CSV header is not 受渡日, コマ, 時間帯 and supply point columns.
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_IMPORT_ISSUE_REASON_HEADER_INVALID = 16;
   */
  HEADER_INVALID = 16,

  /**
   * XML and CSV files were selected together.
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_IMPORT_ISSUE_REASON_MIXED_KINDS = 17;
   */
  MIXED_KINDS = 17,

  /**
   * A 通 would have more supply points than a save can carry.
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_IMPORT_ISSUE_REASON_TOO_MANY_POINTS = 18;
   */
  TOO_MANY_POINTS = 18,

  /**
   * A day of the files is past (a 翌日 通 must be delivered tomorrow or later, a
   * 月間 通 must be next month or later). Used by the 自社の通告値 import; this
   * enum and SplitSupplyPartnerNoticeImportError are shared by both imports.
   *
   * @generated from enum value: SPLIT_SUPPLY_PARTNER_NOTICE_IMPORT_ISSUE_REASON_DATE_CLOSED = 19;
   */
  DATE_CLOSED = 19,
}

/**
 * Describes the enum bffuser.v1.SplitSupplyPartnerNoticeImportIssueReason.
 */
export const SplitSupplyPartnerNoticeImportIssueReasonSchema: GenEnum<SplitSupplyPartnerNoticeImportIssueReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_split_supply_plan_model, 9);

/**
 * SplitSupplyOwnNoticeSkipReason is why a supply point of the files of a 自社の
 * 通告値 import is left out (it is not an error). When several apply, the first
 * of this order is the reason.
 *
 * @generated from enum bffuser.v1.SplitSupplyOwnNoticeSkipReason
 */
export enum SplitSupplyOwnNoticeSkipReason {
  /**
   * @generated from enum value: SPLIT_SUPPLY_OWN_NOTICE_SKIP_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The number is not a supply point of a 変動型 contract the own side takes part in.
   *
   * @generated from enum value: SPLIT_SUPPLY_OWN_NOTICE_SKIP_REASON_NOT_IN_CONTRACT = 1;
   */
  NOT_IN_CONTRACT = 1,

  /**
   * The other company is the one that gives the 通告値 of the point.
   *
   * @generated from enum value: SPLIT_SUPPLY_OWN_NOTICE_SKIP_REASON_PARTNER_NOTIFIER = 2;
   */
  PARTNER_NOTIFIER = 2,

  /**
   * The area of the file's 提出先 differs from the area of the supply point.
   *
   * @generated from enum value: SPLIT_SUPPLY_OWN_NOTICE_SKIP_REASON_AREA_MISMATCH = 3;
   */
  AREA_MISMATCH = 3,

  /**
   * The sender of the XML differs from the own business of the point's 通.
   *
   * @generated from enum value: SPLIT_SUPPLY_OWN_NOTICE_SKIP_REASON_SENDER_MISMATCH = 4;
   */
  SENDER_MISMATCH = 4,

  /**
   * The 負荷追随分供給者 or its 契約識別番号 1 of the XML differs from the contract's.
   *
   * @generated from enum value: SPLIT_SUPPLY_OWN_NOTICE_SKIP_REASON_LOAD_FOLLOWING_MISMATCH = 5;
   */
  LOAD_FOLLOWING_MISMATCH = 5,
}

/**
 * Describes the enum bffuser.v1.SplitSupplyOwnNoticeSkipReason.
 */
export const SplitSupplyOwnNoticeSkipReasonSchema: GenEnum<SplitSupplyOwnNoticeSkipReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_split_supply_plan_model, 10);

/**
 * SplitSupplyOwnNoticeImportPointKind says whether an import creates the 自社の
 * 通告値 of a supply point or overwrites the days the files carry.
 *
 * @generated from enum bffuser.v1.SplitSupplyOwnNoticeImportPointKind
 */
export enum SplitSupplyOwnNoticeImportPointKind {
  /**
   * @generated from enum value: SPLIT_SUPPLY_OWN_NOTICE_IMPORT_POINT_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SPLIT_SUPPLY_OWN_NOTICE_IMPORT_POINT_KIND_NEW = 1;
   */
  NEW = 1,

  /**
   * @generated from enum value: SPLIT_SUPPLY_OWN_NOTICE_IMPORT_POINT_KIND_OVERWRITE = 2;
   */
  OVERWRITE = 2,
}

/**
 * Describes the enum bffuser.v1.SplitSupplyOwnNoticeImportPointKind.
 */
export const SplitSupplyOwnNoticeImportPointKindSchema: GenEnum<SplitSupplyOwnNoticeImportPointKind> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_split_supply_plan_model, 11);

